import React from 'react';
import Select, {components} from 'react-select';
import Creatable from 'react-select/creatable';
import {Controller} from 'react-hook-form';

const customStyles = {
  control: () => ({
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '6px',
    width: '100%',
    display: 'flex',
    border: '1px solid #9ca3af',
    borderRadius: '2px',
  }),
  menu: () => ({
    display: 'none', // Hide dropdown menu
  }),
  dropdownIndicator: () => ({
    display: 'none', // Hide dropdown arrow
  }),
  indicatorSeparator: () => ({
    display: 'none', // Hide separator
  }),
};

/**
 * while using below component in common, make sure "name" should be
 * ex. name="username" or for dynamic form input => name={`questions.${i}.difficulty`}
 */

export const SelectFieldHookForm = ({
  control,
  name,
  options,
  defaultValue = null,
  className = null,
  error = null,
  isLoading = false,
  menuPlacement = 'auto',
  multiple = false,
  creatable = false,
  hideDropdown = false,
  onPaste,
  ...restProps
}) => {
  const SelectComponent = creatable ? Creatable : Select;

  const finalStyles = hideDropdown
    ? {
        ...customStyles,
        control: (provided) => ({
          ...customStyles.control(),
          borderColor: error ? '#ef4444' : '#9ca3af',
        }),
      }
    : {
        ...customStyles,
        control: (provided) => ({
          ...customStyles.control(),
          borderColor: error ? '#ef4444' : '#9ca3af',
        }),
        menu: undefined,
        dropdownIndicator: undefined,
        indicatorSeparator: undefined,
      };

  const customComponents = hideDropdown
    ? {
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        Menu: () => null,
      }
    : {};

  // Add Input component to handle paste events
  if (onPaste) {
    customComponents.Input = (props) => (
      <components.Input {...props} onPaste={onPaste} />
    );
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({field: {onChange, onBlur, value, name, ref}}) => (
        <>
          <SelectComponent
            isMulti={multiple || restProps.isMulti}
            ref={ref}
            styles={finalStyles}
            className={className || 'w-60 bg-white'}
            options={options}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            name={name}
            isLoading={isLoading}
            defaultValue={defaultValue}
            menuPlacement={menuPlacement}
            components={customComponents}
            {...restProps}
          />
          {error && <div className="text-red-500 text-sm pt-1">{error}</div>}
        </>
      )}
    />
  );
};

const SelectField = ({options, className, error, ...restProps}) => {
  return (
    <>
      <Select
        className={className || 'w-full bg-white'}
        styles={customStyles}
        options={options}
        {...restProps}
      />
      {error && <div className="text-error text-sm pt-1">{error}</div>}
    </>
  );
};

export default SelectField;
